import {Injectable} from '@angular/core';
import {Capacitor, registerPlugin} from '@capacitor/core';
import {CapacitorPluginsEnum} from '../../enums/capacitor-plugins.enum';
import {SslCertificatePlugin} from '../../models/ssl-certificate/ssl-certificate-plugin.model';

@Injectable({
    providedIn: 'root'
})
export class SslCertificateService {
    public async hasSslCertificateError(url: string): Promise<boolean> {
        // To prevent circular dependencies, we use directly .getPlatform() instead of the SystemInfoService
        if (Capacitor.getPlatform() !== 'android' || !Capacitor.isPluginAvailable(CapacitorPluginsEnum.sslCertificate)) {
            return false;
        }
        try {
            const plugin = registerPlugin<SslCertificatePlugin>('SslCertificate');
            const result = await plugin.checkServerSslCertificate({ url });
            return result.hasSslError;
        } catch {
            return false;
        }
    }
}
